/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
import { navigateToIndex } from "app/navigation";
import { setFailedRequestUrl } from "reducers/common";
/* Project Import will be here */

const PrivateRoutesAuthWrapper = Component => {
    class PrivateRoutesAuthCheck extends React.Component {
        constructor(props) {
            super(props);

            window.scrollTo(0, 0);
            if (!this.props.localStore.token) {
                /* Capture the current url to redirect after login */
                this.props.actions.setFailedRequestUrl(window.location.pathname);

                /* Redirect to login page when the token not available */
                this.props.actions.navigateToIndex();

                return false;
            }
        }

        renderComp = () => {
            const { appSettings, translate, localStore } = this.props;

            /* Check for auto logout */
            if (localStore.token && !localStore.selectedWholesaler && appSettings.isAppSettingsConfigLoaded) {
                /* Redirect to login page when the token not available */
                this.props.actions.navigateToIndex();
            }

            /* Render private route */
            if (localStore.token && localStore.selectedWholesaler && appSettings.isAppSettingsConfigLoaded)
                return (<Component {...this.props} />);
            else
                return (<div id="overlay"> <Spinner message={translate("common.loading.appLoading")} /> </div>);
        }

        render() { return (this.renderComp()) }
    }

    const mapStateToProps = state => {
        return {
            localStore: state.localStore,
            appSettings: state.appSettings,
            translate: getTranslate(state.locale),
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            actions: bindActionCreators({
                navigateToIndex,
                setFailedRequestUrl
            }, dispatch)
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(PrivateRoutesAuthCheck);
};

export default PrivateRoutesAuthWrapper;